import gql from 'graphql-tag';
const fields = gql`
  fragment MobileNotificationFields on MobileNotification {
    id tip putnikId refId naslov tekst data createdAt createdBy completedAt
  }
`;
export const notificationsEnabledQuery = gql`query NotificationsEnabled { notificationsEnabled }`;
export const activeNotificationsQuery = gql`
  query ActiveNotifications($snapshotToken: String, $cursor: String) {
    activeNotifications(snapshotToken: $snapshotToken, cursor: $cursor, limit: 100) {
      nodes { ...MobileNotificationFields } snapshotToken cursor complete
    }
  } ${fields}
`;
export const closedNotificationsQuery = gql`
  query ClosedNotifications($cursor: String) {
    closedNotifications(cursor: $cursor, limit: 50) {
      nodes { ...MobileNotificationFields } cursor complete
    }
  } ${fields}
`;
export const notificationStatesQuery = gql`
  query NotificationStates($ids: [ID!]!) {
    notificationStates(ids: $ids) { id status notification { ...MobileNotificationFields } }
  } ${fields}
`;
export const completeNotificationMutation = gql`
  mutation CompleteNotification($id: ID!) {
    completeNotification(id: $id) { id status notification { ...MobileNotificationFields } }
  } ${fields}
`;
export const notificationExecutionQuery = gql`
  query NotificationExecution($taskSubjectId: ID!, $executionId: ID!, $taskId: ID!) {
    notificationExecution(taskSubjectId: $taskSubjectId, executionId: $executionId, taskId: $taskId) {
      id taskSubjectId taskId executedAt tekst broj slikaUrl
    }
  }
`;